import React from 'react';

import AnimatedInPlayIcon from '@swf/sports/components/AnimatedInPlayIcon/AnimatedInPlayIcon';

import styles from './GameTime.scss';

const GameTime: React.FC<{ children: React.ReactElement }> = ({ children }) => (
  <div role="timer" className={styles.text}>
    <AnimatedInPlayIcon />
    {children}
  </div>
);

export default GameTime;
